import { KendoBaseComponent, KendoBaseInputComponent } from '@progress/kendo-base-components-vue-wrapper'
import ColorPickerProps from './ColorPickerProps'

import Messages from './Messages'
import TileSize from '../Common/TileSize'

export default {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: ColorPickerProps,
    mixins: [
        KendoBaseComponent,
        KendoBaseInputComponent,
        Messages,
        TileSize
    ],
    mounted() {
        var that = this
        kendo.jQuery(that.$el).kendoColorPicker(that.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }

        that.kendoWidget().bind('change', function(){
            var kendoWidget = that.kendoWidget()
            var inputElement = kendoWidget.element
            if(that.v3){
                that.$emit('update:modelValue', inputElement.val())
            } else {
                that.$emit('changemodel', inputElement.val())
            }
        })
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoColorPicker()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoColorPicker/KendoColorPickerMixin.js